export const errorBoundary = {
  errorBoundaryAPPMessage1: "Oeps! Iets het verkeerd geloop",
  errorBoundaryAPPMessage2: "Ons maak dit reg, herlaai asseblief die bladsy",

  errorBoundaryRedirect1: "Oeps! Iets het verkeerd geloop",
  errorBoundaryRedirect2: "Ons maak dit reg, klik die knoppie om terug te gaan",

  errorBoundaryHandler1: "Oeps! Iets het verkeerd geloop",
  errorBoundaryHandler2: "Probeer om hierdie afdeling te herlaai",

  errorBoundaryBtnReload: "Herlaai",
  errorBoundaryBtnHome: "Terug",
};
